import React, { useState } from 'react';

import AccordionItem from '../../custom-visual-inspection/accordion-item';
import Button from '../../../themed/button';
import Confirm from '../../../themed/confirm';
import Conditional from '../../../common/conditional';
import CustomPECScanItemReadings from './readings';
import PECScanDataItemEditForm from '../../../forms/pec/scan-data/pecScanDataItemEditForm';

import { PECScanData } from '../../../../utils/models';

interface CustomPecScanItemProps {
    onDeletePECScanItem: (item: PECScanData) => void;
    onEditPECScanItem: (updatedItem: PECScanData) => void;
    initialData: PECScanData;
    isOpenOnDefault: boolean;
}

const CustomPecScanItem: React.FC<CustomPecScanItemProps> = ({ isOpenOnDefault, onDeletePECScanItem, initialData, onEditPECScanItem }) => {
    const [editPECScanItem, setEditPECScanItem] = useState(false);
    const [deletePECScanItem, setDeletePECScanItem] = useState(false);

    const handleToggleEditPECScanItem = () => {
        setEditPECScanItem(prev => !prev);
    };

    const handleToggleDeleteInspectionItem = () => {
        setDeletePECScanItem(prev => !prev);
    };

    const handleItemReadingChange = (readings: PECScanData['readings']) => {
        const updatePecScan = { ...initialData, readings };
        onEditPECScanItem(updatePecScan);
    };

    const handleItemUpdate = (updatedItem: PECScanData) => {
        onEditPECScanItem(updatedItem);
        handleToggleEditPECScanItem();
    };

    return ( 
        <AccordionItem isActive isOpenOnDefault={isOpenOnDefault} title={initialData.sectionName}>
            <Conditional isVisible={deletePECScanItem}>
                <Confirm
                    title="Confirm Delete"
                    message="Are you sure you want to delete this section? This action is not reversible!"
                    onCancel={handleToggleDeleteInspectionItem}
                    onConfirm={() => onDeletePECScanItem(initialData)} 
                />
            </Conditional>

            <Conditional isVisible={!deletePECScanItem}>
                <div className="d-flex justify-content-end align-items-center mb-4">
                    <Button label='Edit PEC Scan Data' onClick={handleToggleEditPECScanItem} />
                    
                    <div className="ms-4">
                        <Button 
                            icon='trash' 
                            label='Delete' 
                            style={{ backgroundColor: 'red' }} 
                            onClick={handleToggleDeleteInspectionItem} 
                        />
                    </div>
                </div>
                
                {editPECScanItem ? (
                    <PECScanDataItemEditForm
                        pecScanData={initialData} 
                        onEdit={handleItemUpdate} 
                        onCancelEdit={handleToggleEditPECScanItem} 
                    />
                ) : (
                    <CustomPECScanItemReadings 
                        corrosionAllowance={initialData.corrosionAllowance} 
                        nominalThickness={initialData.nominalThickness} 
                        readings={initialData.readings}
                        onReadingChange={handleItemReadingChange}
                    />
                )}
            </Conditional>
        </AccordionItem>
     );
}
 
export default CustomPecScanItem;